{
  "HubViewBuilders": "Vista builders del hub",
  "backToBuilders": "Volver a todos los builders",
  "AssignmentIdeas": "Asignación de ideas",
  "BuildersOutline": "Esquema de Builders",
  "LessonPlanning": "Planificación de las clases",
  "RebelbaseCurriculum": "Plan de estudios de Rebelbase",
  "IntroTo": "Introduccion a ",
  "next": "Siguiente ",
  "OverviewOf": "Descripción general del ",
  "steps": "pasos",
  "Introduction": "Introducción",
  "Answer": "Responder",
  "Go": "Ir >",
  "Review+Publish": "Revisar + Publicar",
  "backToTopics": "Volver a temas",
  "NoteToHubAdmins": "Nota para los administradores del hub: ",
  "NoteToHubAdminsPhrase": "Tus miembros podrán agregar su respuesta a continuación. Esta respuesta se mostrará en tu perfil de proyecto cuando publiquéis el builder.",
  "skipToAnswer": "Saltar para responder",
  "back": "Atras",
  "GotItNext": "Lo tengo, siguiente",
  "Brief": "Apunte",
  "InspirationByte": "Byte de inspiración",
  "Workshop": "Workshop",
  "Section": "Sección",
  "difficultyLevel": "Nivel de dificultad: ",
  "OnTrack": "Sección actual: ",
  "FaciliationTools": "Herramientas de facilitación",
  "FaciliationTools1": "Guía de lanzamiento del Hub",
  "FaciliationTools2": "El plan de estudios de RebelBase, builders y hub",
  "ChooseYourBuilder": "Escoge tu Builder",
  "Group": "Grupos",
  "changeThisAtAnyTime": "Cambia en cualquier momento",
  "Track": "Sección",
  "HubView": "Vista del Hub",
  "Builders": "BUILDERS",
  "InGroup": "En grupo: ",
  "switchTracksOrGroup": "Cambiar de track o grupo",
  "switchTrack": "Cambiar sección",
  "HubViewPhrase1": "Este es tu espacio para explorar los builders de RebelBase.",
  "readMore": "Leer mas...",
  "HubViewPhrase2Part1": "Esta vista que ves aquí coincide con la que ven los innovadores de tu hub. ",
  "HubViewPhrase2Part2": "Continua y profundiza en el contenido para comprender mejor cómo incorporarlo a tu programa. ",
  "HubViewPhrase2Part3": "Además, hemos proporcionado un conjunto de herramientas de facilitación llenas de consejos y recomendaciones útiles sobre cómo aplicar los builders en contextos variados."
}
